define.alias("shared/components/shared/plan-recommendation/steps/goal", "media/components/shared/plan-recommendation/steps/goal");